import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { HighScarcityStatus } from '@sorare/marketplace/src/components/mySorare/TransactionsHistory/HighScarcityStatus';
import { TRANSACTION_HISTORY_CONTENT_QUERY } from '@sorare/marketplace/src/components/mySorare/TransactionsHistory/query';

const Page = () => {
  const { data } = useQuery(TRANSACTION_HISTORY_CONTENT_QUERY);

  if (!data?.currentUser) return null;

  const { highScarcityStatus } = data.currentUser;
  const showHighScarcityStatus =
    highScarcityStatus?.current?.status ||
    highScarcityStatus?.previous?.status ||
    (highScarcityStatus?.spendLeftToNextStatus?.eurCents &&
      highScarcityStatus.spendLeftToNextStatus.eurCents < 7500);

  if (!showHighScarcityStatus) return null;

  return <HighScarcityStatus currentUser={data.currentUser} />;
};

export default Page;
